import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';

class Footer extends React.Component {

	renderBottomRight() {

		if (this.props.clickBottomRight && this.props.bottomRightMessage) {
			return (
				<div class="lowerRight" onClick={ this.props.clickBottomRight }>
					{ this.props.bottomRightMessage }
				</div>
			);
		} else {
			return (
				<div class="version">
					v1.3.2
				</div>
			);
		}
	}

	renderLeaders() {

		if (this.props.clickLeaders) {
			return (
				<div class="leaders" onClick={ this.props.clickLeaders }>
					{ this.props.leadersText }
				</div>
			);
		}
	}

	renderTutorial() {

		if (this.props.clickTutorial) {
			return (
				<div class="tutorialFooter" onClick={ this.props.clickTutorial }>
					View Tutorial >
				</div>
			);
		}
	}

	renderMid() {

		if (this.props.clickMid) {
			if (this.props.ranked) {
				return (
					<div class="botMid">
						<div class="botMidCenter2" onClick={ this.props.clickMid }>
		                    Click here to play unranked games while we search for a ranked opponent.<br/>
		                    You will be switched to the ranked game when a ranked opponent is found.
	                    </div>
	                </div>
				);//'

			} else {
				return (
					<div class="botMid">
						<div class="botMidCenter" onClick={ this.props.clickMid }>
		                    Can't find a human opponent?  Start a game with bots! <br/>
		                    Other humans can still join if they search for a game
	                    </div>
	                </div>
				);//'
			}
		}
	}

	render() {

        return (
            <div class={this.props.ranked ? "blue2" : "red2"}>
	            { this.renderBottomRight() }
	            { this.renderLeaders() }
	            { this.renderMid() }
	            { this.renderTutorial() }
                <img src="/resources/lc.png"></img>
                <img src="/resources/rc.png"></img>
                <img src="/resources/sp.png"></img>
                <div class="solid"></div>
                <div class="extraKeys">
	            	q key also shoots<br/>
	            	w key also uses powerup
                </div>
                {
                	this.props.clickPrivacySettings &&
	                <div class="subTitle5" style={{top:"3em"}} onClick={this.props.clickPrivacySettings}>
	                    Cookie / Data Preferences
	                </div>
	            }
                <div class="subTitle5" style={{top:"4.75em"}} onClick={() => window.open("https://traitors.sh/resources/privacy.html", "_blank")}>
                    Privacy Policy
                </div>
                <div class="subTitle5" style={{top:"6.5em"}} onClick={() => window.open("https://traitors.sh/resources/termsofservice.html", "_blank")}>
                    Terms of Service
                </div>

            </div>
        );//'
    }
}

Footer.propTypes = {
  bottomRightMessage: PropTypes.string,
  clickBottomRight: PropTypes.func,
  clickTutorial: PropTypes.func,
  clickMid: PropTypes.func,
  clickLeaders: PropTypes.func,
  ranked: PropTypes.bool,
  leadersText: PropTypes.string
};

Footer.defaultProps = {
  leadersText: "Ranked Leaderboards >"
};


export default Footer;